export default __webpack_public_path__ + "static/media/resizeModalIcon.2ee562c8.svg";